import BuyBenefits from '../../../../components/benefits/benefits';
import buyBenefits from './buy-benefits';

export default buyBenefits(BuyBenefits);
